module.exports = __webpack_public_path__ + "img/qr_1.019fc2c8.jpg";